import { ApiError } from '@/api/client'

/** Human-readable message for a failed mutation, surfacing the first field-validation detail. */
export function apiErrorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    const detail = e.details?.[0]
    if (detail) return `${e.message}: ${detail.field} — ${detail.message}`
    return e.message || 'Request failed'
  }
  return 'Something went wrong — try again.'
}
